// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as MoreHorizontalComponent} from './MoreHorizontal.svg';

import Icon, { TIconProps } from '../Icon';

export const IconMoreHorizontal = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <MoreHorizontalComponent/>
  </Icon>
));
